import { useEffect, useMemo, useRef, useState } from 'react';
import "./Chat.scss";
import { MapDispatchToProps, MapStateToProps, connect, useDispatch } from 'react-redux';
import Composer from '../Composer/Composer';
import Messages from '../Messages/Messages';
import { BoundGetConversationHandler, GetConversationHandler, getConversation, queryPinnedMessages } from 'src/chat/redux';
import PinnedMessage from '../PinnedMessage/PinnedMessage';

interface IDispatchProps {
    getConversation: GetConversationHandler | BoundGetConversationHandler;
}

interface IOwnProps {
    conversationId: number;
    scrollToMessageId?: number;
    compact?: boolean;
    blocked?: boolean;
    blockedBy?: boolean;
    onMessageSent?: (message: Spintr.IChatMessage) => void;
}

interface IStateProps {
    conversation: Spintr.IConversation;
    pinnedMessages: Spintr.IChatMessage[];
}

type Props = IDispatchProps & IOwnProps & IStateProps;

const Chat = (props: Props) => {
    const messagesRef = useRef<any>(null);
    const dispatch = useDispatch();
    const [initialLastRead, setInitialLastRead] = useState<{ [id: number]: number } | undefined>(undefined);

    useEffect(() => {
        async function fetchConversation() {
            const promise = (props.getConversation as BoundGetConversationHandler)(props.conversationId);
            const conversation = await promise;

            if ("data" in conversation.value) {
                setInitialLastRead(conversation.value.data.lastRead);
            }
        }

        fetchConversation();

        if ((props.pinnedMessages || []).length === 0) {
            dispatch(queryPinnedMessages({
                conversationId: props.conversationId
            }));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const classes : string = useMemo(() => {
        const result = ["Chat"];

        if (props.compact) {
            result.push("compact");
        }

        return result.join(" ");
    }, [props.compact]);

    return (
        <div className={classes}>
            {(props.pinnedMessages || []).map((m: Spintr.IChatMessage) => {
                return (
                    <PinnedMessage
                        key={m.id}
                        message={m}
                        onClick={() => {
                            messagesRef?.current?.scrollTo(m.id);
                        }}
                    />
                )
            })}
            <Messages
                innerRef={messagesRef}
                initialLastRead={initialLastRead}
                conversationId={props.conversationId}
                scrollToMessageId={props.scrollToMessageId}
                compact={props.compact} />
            <Composer
                conversationId={props.conversationId}
                conversation={props.conversation}
                compact={props.compact}
                blocked={props.blocked}
                blockedBy={props.blockedBy}
                onMessageSent={props.onMessageSent} />
        </div>
    )
}

const mapStateToProps: MapStateToProps<IStateProps, IOwnProps, Spintr.AppState> =
    (state, props): IStateProps => ({
        conversation: state.chat.conversations.items.find(c => c.id === props.conversationId),
        pinnedMessages: state.chat.conversations.pinnedMessages[props.conversationId]
    });

const mapDispatchToProps: MapDispatchToProps<IDispatchProps, IOwnProps> = {
    getConversation
}

export default connect(mapStateToProps, mapDispatchToProps)(Chat);